import "./App.css";
import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Session from "./pages/Session";
import Privacy from "./pages/Privacy";
import { completeAuth } from "./lib/auth";

const AUTH_ERRORS = {
  failed: "Sign-in failed — redirecting",
  unverified: "That Google account has no verified email — redirecting",
  unconfigured: "Google sign-in isn't set up on this server — redirecting",
};

// The backend finishes the OAuth handshake and redirects here with ?auth=...,
// having already set the session cookie.
function AuthCallback({ status }) {
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState(AUTH_ERRORS[status] || null);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      if (status !== "success") {
        setTimeout(() => window.location.replace("/"), 2000);
        return;
      }
      try {
        await completeAuth();
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
        window.location.reload();
      } catch (e) {
        setError(AUTH_ERRORS.failed);
        setTimeout(() => window.location.replace("/"), 2000);
      }
    })();
  }, [navigate, status]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg text-ink">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-white/10 border-t-blu" />
        <div className="mono-label">{error || "Signing you in…"}</div>
      </div>
    </div>
  );
}

function Root() {
  const location = useLocation();
  const authStatus = new URLSearchParams(location.search).get("auth");
  if (authStatus) return <AuthCallback status={authStatus} />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/s/:id" element={<Session />} />
      <Route path="/privacy" element={<Privacy />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Root />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#181C25", border: "1px solid rgba(255,255,255,0.08)", color: "#E6E8EE" } }} />
    </div>
  );
}

export default App;
